import { AfterViewInit, Component,forwardRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { SignaturePad } from 'ngx-signaturepad';
import { MainService } from './main.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppComponent),
      multi: true,
    },
  ],
  
})
export class AppComponent implements AfterViewInit,OnInit{


  @ViewChild(SignaturePad) signaturePad:any;
  today = new Date();
  
  basicInfoForm = new FormGroup({
    title: new FormControl('',
    [
      Validators.required,
      Validators.maxLength(100)]),
    firstName: new FormControl('',
    [
      Validators.required,
      Validators.maxLength(100)]),
    middleName: new FormControl('',
    [
      Validators.maxLength(100)]),
    lastName: new FormControl('',
    [
      Validators.required,
      Validators.maxLength(100)]),
    b_year: new FormControl(this.today.getUTCFullYear(),
    [
      Validators.required,
      Validators.maxLength(100)]),
    b_month: new FormControl(this.today.getUTCMonth()+1,
    [
      Validators.required,
      Validators.maxLength(100)]),
    b_day: new FormControl(this.today.getUTCDate(),
      [
        Validators.required,
        Validators.maxLength(100)]),
    phone: new FormControl('',
    [
      Validators.required,
      Validators.maxLength(100)]),
    workPhone: new FormControl('',
      [
        Validators.maxLength(100)]),
    email: new FormControl('',
    [
      Validators.required,
      Validators.maxLength(100)]),
    });

  addressInfoForm = new FormGroup({
    street: new FormControl('',
    [
      Validators.maxLength(100)]),
    street2: new FormControl('',
    [
      Validators.maxLength(100)]),
    city: new FormControl('',
    [
      Validators.maxLength(100)]),
    state: new FormControl('',
    [
      Validators.maxLength(100)]),
    country: new FormControl('',
    [
      Validators.maxLength(100)]),
    postCode: new FormControl('',
    [
      Validators.maxLength(100)]),
    emergencyContactName : new FormControl('',
    [
      Validators.required,
      Validators.maxLength(100)]),
    emergencyContactRelation : new FormControl('',
    [
      Validators.required,
      Validators.maxLength(100)]),
    emergencyContactPhone : new FormControl('',
    [
      Validators.required,
      Validators.maxLength(100)]),
      emergencyContactPhoneWork: new FormControl('',
      []),
      
  });  
  ChildForm = new FormGroup({
    title: new FormControl('Mr.',
    [
      Validators.required,
      Validators.maxLength(100)]),
    firstName: new FormControl('',
    [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(100)]),
    lastName: new FormControl('',
    [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(100)]),
    b_year: new FormControl(this.today.getUTCFullYear(),
    [
      Validators.required,
      Validators.maxLength(100)]),
    b_month: new FormControl(this.today.getUTCMonth()+1,
    [
      Validators.required,
      Validators.maxLength(100)]),
    b_day: new FormControl(this.today.getUTCDate(),
      [
        Validators.required,
        Validators.maxLength(100)]),
  });

  childSelection:any;
  page:number = 0;
  loading:boolean = false;

  signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth':1,
    'maxWidth':2,
    'dotSize':2,
    'penColor':"black",
    'canvasWidth': 400,
    'canvasHeight': 300
  };
  viewedFull:boolean = false;
  

  ///ADDING CHILDREN THINGS
  yearArray:any[] = new Array(200);  
  daysArray:any[] = new Array(31);
  childrens:any[] = [];
  addingChild:boolean = false;
  editingChild:boolean = false;
  minorAlert:boolean = false;
  constructor(
    private mainService:MainService
    
  ){
    
  }
  
  check_form(mode:any){
    if(mode=="basic"){      
      Object.keys(this.basicInfoForm.controls).forEach(field => { // {1}
        let control = this.basicInfoForm.get(field);            // {2}
        if(control){
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }else if(mode=="address"){
      Object.keys(this.addressInfoForm.controls).forEach(field => { // {1}
        let control = this.addressInfoForm.get(field);            // {2}
        if(control){
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }else if(mode=="child"){
      Object.keys(this.ChildForm.controls).forEach(field => { // {1}
        let control = this.ChildForm.get(field);            // {2}
        if(control){
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
  }
  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad.set('maxWidth', 2.2); // set szimek/signature_pad options at runtime
    this.signaturePad.set('minWidth', 0.2); // set szimek/signature_pad options at runtime
    this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    //this.startOver();
  }
  isMinor(year:number,month:number,day:number){
    let today = new Date();
    let year_diff = today.getFullYear() - year;
    let month_diff = today.getMonth() - (month-1);
    if(month_diff>0){
    }else if(month_diff==0){
      let day_diff = today.getUTCDate() - day; 
      if(day_diff >=0){        
      }else{
        year_diff -=1;
      }
    }else{
      year_diff -=1;
    }
    if(year_diff<16){
      return true;
    }else{
      return false;
    }
      
  }
  ngOnInit(){
    let month = this.ChildForm.get("b_month");
    let year = this.ChildForm.get("b_year");   
    if(month){
      month.valueChanges.subscribe(x=>{
        this.handleYearMonthChange("child");
      });
    }    
    if(year){
      year.valueChanges.subscribe(x=>{
        this.handleYearMonthChange("child");
      });
    }
    month = this.basicInfoForm.get("b_month");
    year = this.basicInfoForm.get("b_year");   
    let day = this.basicInfoForm.get("b_day");   
    if(month){
      month.valueChanges.subscribe(x=>{
        this.handleYearMonthChange("basic");
      });
    }    
    if(year){
      year.valueChanges.subscribe(x=>{
        this.handleYearMonthChange("basic");
      });
    }    
    if(day){
      day.valueChanges.subscribe(x=>{
        this.handleYearMonthChange("basic");
      });
    }    
  }
  
  handleYearMonthChange(mode:string){
    let form = this.ChildForm;
    if(mode=="child"){
      form = this.ChildForm;
    }else if(mode=="basic"){
      form = this.basicInfoForm;
    }
    let month = form.get("b_month");
      let year = form.get("b_year");
      let length = 0;
      if(month){
        if(month.value==2){
          if(year){
            if(year.value%100==0){
              if(year.value%400==0){
                length = 29;  
              }else{
                length = 28;
              }
            }else{
              if(year.value%4==0){
                length = 29;
              }else{
                length = 28;
              }
            }
          }
        }else if([4,6,9,11].includes(month.value)){
          //2467 and 11
          length = 30;
        }else{
          //1357810 12
          length = 31;
        }
      }      
      this.daysArray = new Array(length);
      let day = form.get("b_day");
      if(day){
        if(day.value >length){
          day.setValue(length);
        }
      }
    if(mode=="basic"){
      if(year && month && day){
        this.minorAlert = this.isMinor(year.value,month.value,day.value);
      }
    }
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    //console.log(this.signaturePad.toDataURL());
  }
  clearPad(){
    this.signaturePad.clear();
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    //console.log('begin drawing');
  }
  prevPage(){
    if(this.page==0){
      
    }else{

    }
    this.page = (this.page-1);
  }
  nextPage(){  
    if(this.page==0){
      this.check_form('basic');
      if(!this.basicInfoForm.valid){
        return;
      }
    }else if(this.page==2){
      this.check_form('address');
      let confirmation;
      if(this.addingChild){
        this.check_form("child");
        if(!this.ChildForm.valid){
          return;
        }
        this.addChild();
        /*
        confirmation = confirm("You are in the middle of adding a child, do you wish to abandon your changes and continue?");
        if(!confirmation){
          return;
        }else{
          this.cancelAdd();
        }*/
      }
      if(this.editingChild){
        confirmation = confirm("You are in the middle of editing a child, do you wish to abandon your changes and continue?");
        if(!confirmation){
          return;
        }else{
          this.cancelAdd();
        }
      }
      
      if(!this.addressInfoForm.valid){
        return;
      }
    }else if(this.page==3){
      if(!this.viewedFull){
        return;
      }
    }
    this.page = (this.page+1) %6;
  }
  async submit(){    
    this.loading = true;
    let basicInfoForm = this.basicInfoForm.value;
    basicInfoForm["birthday"] = this.getBirthdayString(basicInfoForm["b_day"],
                                                       basicInfoForm["b_month"],
                                                       basicInfoForm["b_year"]);        
    let error:any = "";
    let data = {
      ...basicInfoForm,
      ...this.addressInfoForm.value,
      "secret": "b1e051ba-56eb-11eb-ae93-0242ac130002",
      "signatureImage":this.signaturePad.toDataURL()
      };
      await this.mainService.submitWaiverForm(
        data
      ).then((result)=>{
        if(result!="got data"){
          error = result;        
        }
    });
    //Sent through children data as well.
    await this.childrens.forEach(async child => {
      data["firstName"] = child["firstName"];
      data["lastName"] = child["lastName"];
      data["title"] = child["title"];
      data["birthday"] = this.getBirthdayString(child["b_day"],
                                                child["b_month"],
                                                child["b_year"]);  
      await this.mainService.submitWaiverForm(
        data
      ).then((result)=>{
        if(result!="got data"){
          error = result;
        }
        this.loading = false;
      });
    });
    //Added children
    if(error!=""){
      alert("Error::"+error);
    }else{
      alert("Success!");
      this.startOver(false);
    }
    this.loading = false;
  }
  getCurrentName(){
    return this.basicInfoForm.value.title + " " +this.basicInfoForm.value.firstName + " " +this.basicInfoForm.value.middleName + " " + this.basicInfoForm.value.lastName 
  }
  startOver(confirm_or_not:boolean){
    if(confirm_or_not==true){
      let confirmation = confirm("are you sure to start over?");
      if(!confirmation){
        return;
      }
    }
    this.childrens = [];
    this.addingChild = false;
    this.editingChild = false;
    this.clearPad();
    this.viewedFull = false;
    this.basicInfoForm.patchValue({
      title: "",
      firstName: "",
      middleName: "",
      lastName: "",
      b_day: this.today.getUTCDate(),
      b_month: this.today.getUTCMonth()+1,
      b_year: this.today.getUTCFullYear(),
      phone: "",
      email: "",      
    });
    this.addressInfoForm.patchValue({
      street: "",
      street2: "",
      city: "",
      state: "",
      country: "",
      postCode: "",
      emergencyContactName : "",
      emergencyContactRelation : "",
      emergencyContactPhone : "",
      emergencyContactPhoneWork:"",
    });
      Object.keys(this.basicInfoForm.controls).forEach(field => { // {1}
        let control = this.basicInfoForm.get(field);            // {2}
        if(control){
          control.markAsUntouched();       // {3}
        }
      });
      Object.keys(this.addressInfoForm.controls).forEach(field => { // {1}
        let control = this.addressInfoForm.get(field);            // {2}
        if(control){
          control.markAsUntouched()       // {3}
        }
      });
      Object.keys(this.ChildForm.controls).forEach(field => { // {1}
        let control = this.ChildForm.get(field);            // {2}
        if(control){
          control.markAsUntouched()       // {3}
        }
      });
    this.page = 0;
  }
  goToPage(pageNum:number){
    if(pageNum>this.page){

    }else{
      this.page = pageNum;
    }
  }
  parseStringDate(date:any){
    let tokens = date.split("-");
    let date_obj = new Date(Number.parseInt(tokens[0]),Number.parseInt(tokens[1])-1,Number.parseInt(tokens[2]));
    return date_obj.toISOString();
} 

onWaiverScroll($event:any) {
  let pos =  $event.srcElement.scrollTop + $event.srcElement.offsetHeight;
  let max = $event.srcElement.scrollHeight;

if(Math.abs(pos - max) <1)   {
  this.viewedFull = true;
 }
 
}
resetChildForm(){
  this.ChildForm.patchValue({
    title:"Mr.",
    firstName:"",
    lastName:"",
    b_year:this.today.getUTCFullYear(),
    b_month:this.today.getUTCMonth()+1,
    b_day:this.today.getUTCDate()
  });
}
cancelAdd(){
  this.resetChildForm();
  this.addingChild = false;
  this.editingChild = false;
}
deleteAdd(){
  if(this.editingChild==true){
    this.childrens = this.childrens.filter((child)=>child!=this.childSelection);
  }
  this.cancelAdd();
}
makeNormal(num:number){
  if(num.toString().length<2){
    return "0"+num.toString();
  }else{
    return num.toString();
  }
}
getBirthdayString(day:number,month:number,year:number){
  return this.makeNormal(month)+"-"+this.makeNormal(day)+"-" + year.toString();
}
addChild(){
  this.check_form("child");
  if(!this.ChildForm.valid){
    return;
  }
  let title = this.ChildForm.get("title");
  let firstName = this.ChildForm.get("firstName");
  let lastName = this.ChildForm.get("lastName");
  let b_day = this.ChildForm.get("b_day");
  let b_month = this.ChildForm.get("b_month");
  let b_year = this.ChildForm.get("b_year"); 
 let child = {   
  title: title ? title.value : "",
  firstName:firstName ? firstName.value : "",
  lastName: lastName ? lastName.value: "",
  b_day: b_day ? b_day.value : "",
  b_month: b_month ? b_month.value : "",
  b_year: b_year ? b_year.value : "",
 } 
this.childrens.push(child);
if(this.editingChild==true){
  this.childrens = this.childrens.filter((child)=>child!=this.childSelection);
}
this.childSelection = child;
this.cancelAdd();
}

editChild(child:any){
  if(!child){
    return;
  }else{
    this.childSelection = child;
  }
  this.ChildForm.patchValue(
    this.childSelection
  );  
  this.editingChild = true;
  this.addingChild = true;
}
}

